import { useContext } from 'react';
import { CombinedFeedContext } from '../../../context/CombinedFeedContext';

// components
import BasicButton from  '@/components/elements/global/buttons/BasicButton/BasicButton';
import { CancelConfirmModal, SimpleTable } from 'thrive-components';
import { AddSourceListExplainer, EditSourceListButtonContent, SavingFeedAsDraft } from  '@/components/elements/combinedFeed/buttons';
import SimplePageSelector from  '@/components/elements/global/PageSelectors/SimplePageSelector';

// interfaces
import {listTableColumns} from  '@/components/elements/lists/ListConstants';


const EditSourceListsView = () => {
    const {contentItems, handleModalOpen, modalOpen, formatCombinedFeedContent, hasEditorRights, savingContent, paginationSettingsSL, updateSourceListContent, sourceLists, onSourceListReset, isAlteringSL, showConfirmationModal, setShowConfirmationModal} = useContext(CombinedFeedContext)

    return (<>
        <div className='list-actions-wrapper'>
            {hasEditorRights && 
                <>
                <BasicButton 
                    content={'Remove All'} 
                    ariaLabel={'Remove all source lists'}
                    className='remove-all-button'
                    isDisabled={sourceLists?.length < 1}
                    onButtonClick={()=>setShowConfirmationModal(true)}
                />

                <BasicButton 
                    className="source-lists-button"
                    content={savingContent ? <SavingFeedAsDraft /> : <EditSourceListButtonContent isLoading={false} isEdit={contentItems?.length > 0}/> }
                    ariaLabel={modalOpen ? 'Close modal' : 'Add Source Lists'}
                    onButtonClick={() => handleModalOpen(!modalOpen)}
                    isDisabled={savingContent}
                />
            </>
            }
        </div>

        {sourceLists?.length > 0
            ?   <SimpleTable 
                    simpleTableContent={{columns: listTableColumns, rows: formatCombinedFeedContent(sourceLists, true)}} 
                    paginationInformation={paginationSettingsSL}
                    isLoading={isAlteringSL}
                    isPaginated={true}
                    isInfiniteScroll={false}
                    isDragAndDrop={false}
                    noDataMessage='No items to display'
                />
            
            :   <AddSourceListExplainer />
        }
                            
        {paginationSettingsSL?.hasPagination && 
            <div className='page-selector-wrapper'>
                <SimplePageSelector
                    currentPage={paginationSettingsSL.currentPage}
                    totalPages={paginationSettingsSL.totalPages}
                    setPage={(page) => {updateSourceListContent(page)}}
                />
            </div>
        }

        {showConfirmationModal &&
            <CancelConfirmModal 
                className='remove-all-source-lists-modal'
                headerContent={"Remove all source lists?"} 
                bodyContent={"This will remove every source list from this feed. Content from those lists will no longer appear in the combined feed?"} 
                onCloseClick={()=>setShowConfirmationModal(false)}  
                cancelButtonText={'Cancel'} 
                cancelButtonAriaLabel={'Cancel and keep all selected source lists'} 
                confirmButtonText={'Confirm'} 
                confirmButtonAriaLabel={'Confirm and remove all source lists'} 
                onCancelClick={()=>setShowConfirmationModal(false)} 
                onConfirmClick={()=>onSourceListReset()}
            />
        }
    </>)
}

export default EditSourceListsView